import { render } from "./TemplateDemandBooking3.vue?vue&type=template&id=6e99dbe3"
import script from "./TemplateDemandBooking3.vue?vue&type=script&lang=js"
export * from "./TemplateDemandBooking3.vue?vue&type=script&lang=js"

import "./TemplateDemandBooking3.vue?vue&type=style&index=0&id=6e99dbe3&lang=scss"
script.render = render

export default script